import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000"
});

export const { signIn, signOut, signUp, useSession, forgetPassword, resetPassword } = authClient;

// Google OAuth 登录辅助函数
export const signInWithGoogle = async () => {
  // 获取当前完整 URL（包括路径和查询参数）
  const currentUrl = window.location.href;

  return authClient.signIn.social({
    provider: "google",
    callbackURL: currentUrl, // 登录成功后返回当前页面
  });
};

